import { DragIndicator, Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Checkbox } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { GREY } from '../../../../constants/color';

const ColumnControl = ({ column, index, columnVisible, onColumnVisibilityChange }) => {
  const labelId = `column-control-label-${index}`;
  return (
    <Draggable draggableId={column.field} index={index} isDragDisabled={!columnVisible}>
      {(provided, snapshot) => (
        <Box
          sx={{
            display: 'flex',
            gap: '12px',
            fontSize: '14px',
            borderRadius: '8px',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={classNames({ 'bg-neutral-100': snapshot.isDragging })}
        >
          <DragIndicator sx={{ opacity: 0.2 }} />
          <p className={classNames('flex-1', { [`text-[${GREY}]`]: !columnVisible })} id={labelId}>
            {column.headerName}
          </p>
          <Checkbox
            onChange={onColumnVisibilityChange(column.field)}
            checked={columnVisible}
            inputProps={{ 'aria-labelledby': labelId }}
            checkedIcon={<Visibility sx={{ height: '16px', width: '16px' }} />}
            icon={<VisibilityOff sx={{ height: '16px', width: '16px' }} />}
          />
        </Box>
      )}
    </Draggable>
  );
};

ColumnControl.propTypes = {
  column: PropTypes.object,
  columnVisible: PropTypes.bool,
  onColumnVisibilityChange: PropTypes.func,
  index: PropTypes.number,
};

export default ColumnControl;
